import { useTranslation } from "react-i18next";
import { ApplicationSubtype, BoxSpg, DividerSpg } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import { completeEducationStep, setStepEducationEdited } from "../../../../../../store/redux/slice/Forms/regprofForm";
import { toast } from "react-toastify";
import { Button, Typography } from "@mui/material";
import CountryFormSection from "./section/CountryFormSection";
import RegprofEducationFormSection from "./section/RegprofEducationFormSection";
import RegprofExperienceFormSection from "./section/RegprofExperienceFormSection";
import ProfessionalQualificationFormSection from "./section/ProfessionalQualificationFormSection";
import { createRegprofEducationDetailsValidationSchema } from "../../../../../../yup/regprof/regprofEducationDetailsValidationSchema";
import { initialRegprofEducationDetails } from "../../../../../../init/regprofInitialValues";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import RegprofApplicationDetailsFormSection from "./section/RegprofApplicationDetailsFormSection";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import RegprofFeesSection from "./section/RegprofFeesSection";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";

const RegprofStepEducation = () => {
  const { t } = useTranslation();

  const regprofForm = useAppSelector((state) => {
    return state.Forms.RegprofForm;
  });

  const fullSchema = createRegprofEducationDetailsValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    regprofForm.educationDetails,
    regprofForm.id,
    baseEndpointPaths.regprof,
    formalSchema,
    setStepEducationEdited,
    completeEducationStep,
    initialRegprofEducationDetails,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.REGULATED_PROFESSIONS, regprofForm.educationDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            console.log(errors);
            toast.error(t("m.validation.errors.present"));
          })}
        >
          <RegprofFeesSection />
          <RegprofApplicationDetailsFormSection />
          <CountryFormSection />
          <RegprofEducationFormSection />
          <RegprofExperienceFormSection />
          <ProfessionalQualificationFormSection />

          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default RegprofStepEducation;
